export function isSyntheticWorkspaceEmail(email?: string | null): boolean {
  return !!email && email.endsWith('@workspace.payhelm')
}

/** Personal login email — never the synthetic org workspace address. */
export function resolvePersonalAccountEmail(
  user?: { email?: string; home_user_email?: string } | null,
  homeUserEmail?: string | null
): string {
  if (user?.home_user_email) return user.home_user_email
  if (homeUserEmail) return homeUserEmail
  if (user?.email && !isSyntheticWorkspaceEmail(user.email)) return user.email
  return ''
}

/** Raw org identifiers (e.g. `org.89fbc8ce621d410d…`) are never a human-readable name. */
export function isOrgIdLabel(value?: string | null): boolean {
  return !!value && /^org\.[0-9a-f]{8,}/i.test(value.trim())
}

export function resolveAccountDisplayLabel(options: {
  profileDisplayName?: string | null
  userName?: string | null
  personalEmail?: string | null
}): string {
  const { profileDisplayName, userName, personalEmail } = options
  const readable = (v?: string | null) => (v && !isOrgIdLabel(v) ? v : '')
  return readable(profileDisplayName) || readable(userName) || personalEmail || 'Account'
}
